import React from 'react';
import PropTypes from 'prop-types';
import { Box, CircularProgress } from '@material-ui/core';
import {
  BubbleChild,
  BubbleContainer,
  Quantity,
  SubTitle,
  Title,
  Container
} from './style';

/**
 *
 * Bulle d'affichage des stats expédition, préparation, livraison
 *
 * @param {Boolean} value      Valeur de la KPI
 * @param {String}  image      Url du logo svg
 * @param {String}  title      Titre de la bulle
 * @param {String}  subTitle   Sous titre de la bulle
 * @param {String}  onClick    Action au click sur la bulle
 * @param {String}  loading    Afficher le loader
 *
 */
const Bubble = ({ quantity, logo, title, subTitle, onClick, loading }) => (
  <Container onClick={onClick} style={{ cursor: onClick ? 'pointer' : '' }}>
    <BubbleContainer>
      <BubbleChild>
        <img src={logo} alt="return logo" />
      </BubbleChild>
      {loading ? <CircularProgress /> : <Quantity>{quantity}</Quantity>}
    </BubbleContainer>
    <Box ml={3}>
      <Title>{title}</Title>
      <SubTitle>{subTitle}</SubTitle>
    </Box>
  </Container>
);

Bubble.propTypes = {
  quantity: PropTypes.number,
  logo: PropTypes.string,
  loading: PropTypes.bool,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  onClick: PropTypes.func
};

export default Bubble;
